import { ShHeadersService } from 'projects/shared/src/public-api';

export const environment = {
  production: false,
  baseUrl: 'https://app.dev.apilab.bancodelaustro.com',
  accessControl: ShHeadersService.getAccessControlDevelopment,
  token: ShHeadersService.tokenDevelopment,
  microfrontends: {
    layout: {
      remoteEntry:
        'https://app.dev.credivehiculos.bancodelaustro.com/mfe/layout/remoteEntry.js',
      remoteName: 'layout',
      exposedModule: ['Header', 'Footer', 'LayoutModule'],
    },
    applicant: {
      remoteEntry:
        'https://app.dev.credivehiculos.bancodelaustro.com/mfe/applicant/remoteEntry.js',
      remoteName: 'applicant',
    },
    creditSimulation: {
      remoteEntry:
        'https://app.dev.credivehiculos.bancodelaustro.com/mfe/credit-simulation/remoteEntry.js',
      remoteName: 'creditSimulation',
    },
    documents: {
      remoteEntry:
        'https://app.dev.credivehiculos.bancodelaustro.com/mfe/mf-documents/remoteEntry.js',
      remoteName: 'documents',
    },
    semaphore: {
      remoteEntry:
        'https://app.dev.credivehiculos.bancodelaustro.com/mfe/semaphore/remoteEntry.js',
      remoteName: 'semaphore',
    },
    dashboard: {
      remoteEntry:
        'https://app.dev.credivehiculos.bancodelaustro.com/mfe/dashboard/remoteEntry.js',
      remoteName: 'dashboard',
    },
    loginSeller: {
      remoteEntry:
        'https://app.dev.credivehiculos.bancodelaustro.com/mfe/login-seller/remoteEntry.js',
      remoteName: 'loginSeller',
    },
    loanApplication: {
      remoteEntry:
        'https://app.dev.credivehiculos.bancodelaustro.com/mfe/mf-loan-application/remoteEntry.js',
      remoteName: 'loan-application',
    },
    creditCalculator: {
      remoteEntry:
        'https://app.dev.credivehiculos.bancodelaustro.com/mfe/credit-calculator/remoteEntry.js',
      remoteName: 'creditCalculator',
    },
    creditDelay: {
      remoteEntry:
        'https://app.dev.credivehiculos.bancodelaustro.com/mfe/mf-credit-delay/remoteEntry.js',
      remoteName: 'creditDelay',
    },
  },
  cognito: {
    identityPoolId: '',
    region: 'us-east-1',
    /* userPoolId: 'us-east-1_BViNLPAZW',
    userPoolWebClientId: '7l58broj906ds4bmep13hf1iev', */
    userPoolId: 'us-east-1_0dmehPQW5',
    userPoolWebClientId: '2k0p6d6n0tjeeg0665pfajbhjl',

    mandatorySignIn: false,

    oauth: {
      domain: 'login.dev.credivehiculos.bancodelaustro.com',
      scope: [
        'phone',
        'email',
        'profile',
        'openid',
        'aws.cognito.signin.user.admin',
      ],
      redirectSignIn:
        'https://app.dev.credivehiculos.bancodelaustro.com/dashboard',
      redirectSignOut:
        'https://app.dev.credivehiculos.bancodelaustro.com/loginSeller',
      responseType: 'code',
      options: {
        AdvancedSecurityDataCollectionFlag: false,
      },
    },
  },
  Storage: {
    bucket: '',
    region: 'us-east-1',
  },
  GTM: {
    id: 'GTM-PBKTT4FJ',
    description: 'Datos para google tag manager DEV',
    url: 'https://www.googletagmanager.com/ns.html?id=GTM-PBKTT4FJ',
  },
  GA: {
    id: 'G-B2MKCJWNE6',
    description: 'Datos para google analitics DEV',
    url: 'https://www.googletagmanager.com/gtag/js?id=G-B2MKCJWNE6',
  },
  manifest: '/assets/mf.manifest.json',
};
